import MswAppTitle  from './msw-app-title.vue';
export { default as browserTitles } from './browserTitlesDictionary';
export {
  MswAppTitle,
};
